<template>
  <div>
    <el-col :span="7">
      <TenantidListView ref="external" @select="bindSelect" :tenantCount="brandsum" :onlyshowstore="true"></TenantidListView>
    </el-col>
    <el-col :span="17">
      <div class="brandManageContent">
        <el-card class="box-card" style="min-height: 40px">
          <el-input placeholder="请输入关键字" v-model="searchcontent" size="mini" style="width:260px;margin-bottom: 10px">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input><br>
          已选择：  <el-tag size="mini" effect="plain" v-if="child.isActive" :key="child.customerserial" v-for="child in brandList">{{child.deptname}}</el-tag>
        </el-card>
        <el-card class="box-card" >
          <div slot="header" class="clearfix">
            <span style="font-size: 14pt">{{tenantname}}</span><span style="padding-left: 30px;font-weight: bolder">{{totalnumber}}</span>
          </div>
          <el-button :loading="loading" :icon="child.isActive?'el-icon-check':'el-icon-shopping-cart-2'"
                     :plain="!child.isActive" :type="child.isActive?'primary':'info'" v-for="(child,childIndex) in brandList" :key="childIndex" @click="chooseItem(child)"
                     v-if="child.deptname.indexOf(searchcontent)>-1"
                     style="margin: 10px;min-width: 250px">{{child.deptname}}</el-button>
        </el-card>
      </div>
    </el-col>
  </div>
</template>

<script>
  import TenantidListView from '@/components/sysmanage/TenantidListView';
  import {getListData,listUseRight,countUseRight,removeUseRight,saveUseRight} from '@/api/set/externaldept';

  export default {
    name: 'ExternaldeptRight',
    data() {
      return {
        formLabelWidth: '120px',
        dialogFormVisible: false,
        tenantid: '',
        tenantname: '',
        independentserial: '',
        searchcontent:'',
        loading: false,
        brandList: [],
        brandsum: [],
        totalnumber: 0,
        pagination: {
          currentPage: 1,
          pageSize: 100,
          total: 0
        },
        tableData: [],
        spanArr: [],
        pos: 0
      }
    },
    methods: {
      chooseItem(brand) {
        if (!this.tenantid) return;
        this.loading = true;
        if (brand.isActive) {//删除
          removeUseRight({customerserial: brand.customerserial, tenantid: this.tenantid}).then(response => {
            this.loading = false;
            if (response.data.code == 0) {
              this.totalnumber -= 1;
              this.changeNum(-1);
              this.$set(brand, 'isActive', false);
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
          })
        } else {//增加
          saveUseRight({customerserial: brand.customerserial, tenantid: this.tenantid}).then(response => {
            this.loading = false;
            this.totalnumber += 1;
            this.changeNum(1);
            this.$set(brand, 'isActive', true);
          })
        }
      },
      changeNum(number) {
        var hasValue = false;
        for (let i in this.brandsum) {
          if (this.brandsum[i].tenantid == this.tenantid) {
            hasValue = true;
            if (!this.brandsum[i].member) this.brandsum[i].member = number;
            else this.brandsum[i].member += number;
          }
        }
        if (!hasValue) {
          this.brandsum.push({tenantid: this.tenantid, member:this.totalnumber});
        }
      },
      bindSelect(tenantid, tenantname) {
        this.tenantid = tenantid;
        this.tenantname = tenantname;
        this.bindGrid();
      },
      bindGrid() {
        this.clearActive(this.brandList);
        listUseRight({tenantid: this.tenantid}).then(response => {
          var row = response.data.obj;
          for (let i in row) {
            for (let j in this.brandList) {
              if (this.brandList[j].customerserial == row[i].customerserial) {
                this.brandList[j].isActive = true;
                this.totalnumber += 1;
                break;
              }
            }
          }
        });
      },
      clearActive(rows) {
        this.totalnumber = 0;
        for (let i in rows) {
          rows[i].isActive = false;
        }
      }
    },
    mounted() {
      getListData({offset: 0, limit: 1000, unitgroup: '3', disabled: ''}).then(response => {
        var rows = response.data.obj.rows;
        this.clearActive(rows);
        rows.sort((a, b) => a.deptname.localeCompare(b.deptname));
        this.brandList = rows;
      })
      var paraRight={};
      let model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      if (model.tenantid != "d6d0f500-6c34-45e6-b206-b87c368e4469"){
        paraRight.tenantidpre=model.tenantid ;
      }
      countUseRight(paraRight).then(response => {
        this.brandsum = []
        var nums = response.data.obj;
        for (var i in nums) {
          if (!(nums[i].member > 0)) nums[i].member = 0;
          this.brandsum.push({tenantid: nums[i].tenantid, member: nums[i].member})
        }
      })
    },
    components: {
      TenantidListView,
    }
  }
</script>

<style  scoped>
  .brandManagePage{
    display: flex;
    border: 0px solid #ccc;
  }

  .brandManagePage .classBox{
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 15%;
    background: #eaf4ff;
    padding: 0px 0;
    color: #333;
    height: 100%;
    overflow: auto;
  }

  .brandManagePage .brandManageContent {
    padding: 0px 15px 0px 15px;
    width: 85%;
    margin: 0 auto;
    height: 100%;
    overflow: auto;
  }

  .classItem.isActive {
    color: #3e96f7;
  }

  .classItem {
    cursor: pointer;
    padding: 0 27px 0 30px;
    position: relative;
    text-align: left;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
  }


  .box-card {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px;
    min-height: 180px;
    text-align: left;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix span{
    float:left;
    font-weight:600;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptRight.vue